import { useThemeMode } from '@/contexts/ThemeContext'
import { componentStyles } from '@/lib/theme'

interface ConfirmationScreenProps {
  onBackToLogin: () => void
}

export default function ConfirmationScreen({
  onBackToLogin,
}: ConfirmationScreenProps) {
  const { colors } = useThemeMode()

  return (
    <div style={componentStyles.authWindow.confirmContainer}>
      <h2 style={{ ...componentStyles.authWindow.confirmHeading, color: colors.primaryText }}>
        Account Created Successfully!
      </h2>
      <div style={{ ...componentStyles.authWindow.confirmText, color: colors.secondaryText }}>
        <p style={componentStyles.authWindow.confirmParagraph}>
          Thank you for signing up! We've sent a confirmation email to your
          inbox.
        </p>
        <p style={{
          ...componentStyles.authWindow.confirmParagraph,
          backgroundColor: colors.primaryAccent + '20',
          border: `2px solid ${colors.primaryAccent}`,
          borderRadius: '6px',
          padding: '12px',
          color: colors.primaryText,
          fontWeight: '600',
          marginTop: '16px',
          marginBottom: '16px',
        }}>
          📧 Please check your email and click the confirmation link to activate
          your account.
        </p>
        <p style={componentStyles.authWindow.confirmNote}>
          Don't see the email? Check your spam folder or try signing up again.
        </p>
      </div>
      <button
        onClick={onBackToLogin}
        style={{
          ...componentStyles.authWindow.confirmButton,
          background: colors.secondaryBg,
          color: colors.primaryText,
          border: `1px solid ${colors.primaryBorder}`,
        }}
      >
        Back to Login
      </button>
    </div>
  )
}
